import { Navigate, useLocation } from "react-router-dom";

/**
 * A route element that sends a bookmark of a retired report page to its v2
 * report. The old pages showed figures and labels the v2 reports had since
 * corrected, so they are gone rather than kept beside them. `?id=` (the
 * business the old page was opened for) rides along; nothing else did there.
 */
export const legacyReportRedirect = (to) => {
  const LegacyReportRedirect = () => {
    const { search } = useLocation();
    const id = new URLSearchParams(search).get("id");
    const query = id ? `?${new URLSearchParams({ id })}` : "";
    return <Navigate replace to={`${to}${query}`} />;
  };
  return LegacyReportRedirect;
};

export default legacyReportRedirect;
